import * as React from 'react';
import { cn } from '@/lib/utils';

const SkillEvaluation = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation',
      // styles
      'flex flex-col gap-8 overflow-auto rounded-lg border border-solid border-[#ECE9F8] bg-white p-8 shadow-dropshadow',
      className
    )}
    {...props}
  />
));
SkillEvaluation.displayName = 'SkillEvaluation';

const SkillEvaluationHeader = React.forwardRef(({ className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn(
      'c-skill-evaluation-header',
      // styles
      'flex flex-col gap-2',
      className
    )}
    {...props}
  />
));
SkillEvaluationHeader.displayName = 'SkillEvaluationHeader';

const SkillEvaluationBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-body',
      // styles
      'flex flex-col lg:flex-row',
      className
    )}
    {...props}
  />
));
SkillEvaluationBody.displayName = 'SkillEvaluationBody';

const SkillEvaluationCol = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-col',
      // styles
      'relative mb-8 w-full border-b border-solid border-[#ECE9F8] pb-8 last:border-0 lg:mb-0 lg:mr-8 lg:border-b-0 lg:border-r lg:border-solid lg:pb-0 lg:pr-8',
      className
    )}
    {...props}
  />
));
SkillEvaluationCol.displayName = 'SkillEvaluationCol';

const SkillEvaluationEssay = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-essay',
      // styles
      'flex flex-col gap-3',
      className
    )}
    {...props}
  />
));
SkillEvaluationEssay.displayName = 'SkillEvaluationEssay';

const SkillEvaluationEssayHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-essay-header',
      // styles
      'flex items-center justify-between gap-4',
      className
    )}
    {...props}
  />
));
SkillEvaluationEssayHeader.displayName = 'SkillEvaluationEssayHeader';

const SkillEvaluationEssayText = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-essay-text',
      // styles
      'relative m-0 h-[700px] overflow-auto',
      className
    )}
    {...props}
  />
));
SkillEvaluationEssayText.displayName = 'SkillEvaluationEssayText';

const SkillEvaluationEssayTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'c-skill-evaluation-essay-title',
      // styles
      'mb-0 text-base font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
SkillEvaluationEssayTitle.displayName = 'SkillEvaluationEssayTitle';

const SkillEvaluationEssayMark = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-skill-evaluation-essay-mark',
      // styles
      'z-1 absolute left-0 top-0 select-none text-justify',
      className
    )}
    {...props}
  />
));
SkillEvaluationEssayMark.displayName = 'SkillEvaluationEssayMark';

const SkillEvaluationCompetence = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-competence',
      // styles
      'relative flex flex-col gap-8',
      className
    )}
    {...props}
  />
));
SkillEvaluationCompetence.displayName = 'SkillEvaluationCompetence';

const SkillEvaluationCompetenceTag = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-competence-tag',
      // styles
      'absolute right-[-45px] top-0 inline-flex w-[132px] translate-y-[-100%] flex-col items-center gap-1 rounded-l-lg border border-solid border-[#ECE9F8] bg-white shadow-dropshadow',
      "after:absolute after:bottom-[-11px] after:right-[3px] after:after:h-0 after:w-0 after:rotate-45 after:border-[10px] after:border-transparent after:border-r-[#ECE9F8] after:content-['']",
      className
    )}
    {...props}
  />
));
SkillEvaluationCompetenceTag.displayName = 'SkillEvaluationCompetenceTag';

const SkillEvaluationTip = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-tip',
      // styles
      'relative flex flex-col gap-2 rounded-lg border border-solid border-[#ECE9F8] bg-[linear-gradient(10deg,#FFF_20.02%,#F5F5F5_85.13%)] p-5 text-[#5D6A86] shadow-dropshadow',
      className
    )}
    {...props}
  />
));
SkillEvaluationTip.displayName = 'SkillEvaluationTip';

const SkillEvaluationPoints = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-skill-evaluation-points',
      // styles
      'flex w-fit items-center justify-center rounded border border-solid px-2 font-bold text-[#5D6A86]',
      className
    )}
    {...props}
  />
));
SkillEvaluationPoints.displayName = 'SkillEvaluationPoints';

export {
  SkillEvaluation,
  SkillEvaluationHeader,
  SkillEvaluationBody,
  SkillEvaluationCol,
  SkillEvaluationEssay,
  SkillEvaluationEssayHeader,
  SkillEvaluationEssayText,
  SkillEvaluationEssayTitle,
  SkillEvaluationEssayMark,
  SkillEvaluationCompetence,
  SkillEvaluationCompetenceTag,
  SkillEvaluationTip,
  SkillEvaluationPoints
};
